import { createContext } from 'react';

const FlightTrackingContext = createContext();

export default FlightTrackingContext;
